export function PageHeader({ title, subtitle, children, testid }) {
  return (
    <div className="flex items-start justify-between gap-4 flex-wrap" data-testid={testid}>
      <div>
        <h1 className="font-head text-2xl font-bold tracking-tight text-slate-100">{title}</h1>
        {subtitle && <p className="text-sm text-slate-400 mt-1 max-w-2xl">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2">{children}</div>
    </div>
  );
}

export function Card({ className = "", children, ...rest }) {
  return (
    <div className={`glass rounded-xl ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function Pill({ tone = "slate", children }) {
  const tones = {
    slate: "bg-slate-700/40 text-slate-300 border-slate-600/40",
    emerald: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
    amber: "bg-amber-500/15 text-amber-300 border-amber-500/30",
    red: "bg-red-500/15 text-red-300 border-red-500/30",
    blue: "bg-blue-500/15 text-blue-300 border-blue-500/30",
  };
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-mono uppercase tracking-wider border ${tones[tone] || tones.slate}`}>
      {children}
    </span>
  );
}

export function EmptyState({ icon: Icon, title, hint }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 text-slate-500">
      {Icon && <Icon className="w-10 h-10 mb-3 text-slate-600" />}
      <p className="text-slate-300 font-medium">{title}</p>
      {hint && <p className="text-sm mt-1 max-w-sm">{hint}</p>}
    </div>
  );
}

export function Spinner({ label }) {
  return (
    <div className="flex items-center gap-2 text-slate-400 text-sm">
      <span className="w-4 h-4 rounded-full border-2 border-emerald-500/40 border-t-emerald-400 animate-spin" />
      {label}
    </div>
  );
}
